/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewDomainsDns
 */
export interface CRSFSecReviewDomainsDns {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFSecReviewDomainsDns
     */
    results: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainsDns
     */
    total: number;
}

/**
 * Check if a given object implements the CRSFSecReviewDomainsDns interface.
 */
export function instanceOfCRSFSecReviewDomainsDns(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFSecReviewDomainsDnsFromJSON(json: any): CRSFSecReviewDomainsDns {
    return CRSFSecReviewDomainsDnsFromJSONTyped(json, false);
}

export function CRSFSecReviewDomainsDnsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDomainsDns {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': json['results'],
        'total': json['total'],
    };
}

export function CRSFSecReviewDomainsDnsToJSON(value?: CRSFSecReviewDomainsDns | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results,
        'total': value.total,
    };
}

